var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2948,
    cy: 13.2148,
    r: 12.7595,
    stroke: "white",
    strokeWidth: 0.911392
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_928)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1315 4.99417C16.5023 4.99417 16.8666 5.14475 17.1291 5.40734L19.8727 8.15088C20.139 8.41723 20.2858 8.77204 20.2858 9.14852V20.9942H7.10938V4.99417H16.1315ZM15.58 5.93534H8.05054V20.053H19.3447V9.70005H15.58V5.93533L15.58 5.93534ZM16.5211 6.13017V8.75888H19.1498L16.5211 6.13017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2053 10.6407C13.4284 10.6407 13.6251 10.7461 13.7719 10.956C14.1211 11.4482 14.0966 11.9725 13.9677 12.6783C13.9234 12.9212 13.9686 13.1668 14.1032 13.3711C14.2933 13.6609 14.5672 14.06 14.8364 14.3979C15.034 14.6473 15.338 14.78 15.6458 14.7386C15.8434 14.7113 16.0815 14.6887 16.3262 14.6887C17.418 14.6887 17.3361 15.0783 17.4349 15.436C17.4895 15.6525 17.4622 15.8416 17.3502 15.9819C17.2109 16.1711 16.9239 16.2689 16.5041 16.2689C16.0392 16.2689 15.8858 16.1899 15.4811 16.0609C15.2524 15.9875 15.0152 15.9725 14.7836 16.0336C14.3215 16.1541 13.5592 16.3376 12.9229 16.4252C12.5832 16.4722 12.2745 16.6473 12.0693 16.9325C11.6072 17.5725 11.1789 18.1701 10.5004 18.1701C10.3253 18.1701 10.1644 18.1071 10.0317 17.9809C9.83589 17.7852 9.75212 17.5678 9.79354 17.3155C9.90836 16.5409 10.8608 16.1089 11.4274 15.7936C11.5611 15.7193 11.6665 15.6054 11.7324 15.4642L12.6312 13.5207C12.6952 13.3842 12.7149 13.2327 12.6914 13.0831C12.5869 12.4242 12.4326 11.3165 12.8477 10.8158C12.9389 10.7038 13.0651 10.6407 13.2053 10.6407ZM13.3766 13.4736C13.0161 14.5287 12.3789 15.676 12.2933 15.8096C13.0622 15.4482 14.5926 15.2656 14.5926 15.2656C13.8227 14.524 13.3766 13.4736 13.3766 13.4736Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5.70068 4.99963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCircle);
export default __webpack_public_path__ + "static/media/pdf-circle.f6bdd68d47a83e333861bd19ba90c204.svg";
export { ForwardRef as ReactComponent };